/**
 * axisPointer 组件扩展
 *
 * @see https://echarts.apache.org/zh/option.html#axisPointer
 */
import { type EChartsExtensionInstallRegisters } from 'echarts/lib/extension';
import CartesianAxisPointer from 'echarts/lib/component/axisPointer/CartesianAxisPointer';
import BaseAxisPointer, {
  type AxisPointerElementOptions
} from 'echarts/lib/component/axisPointer/BaseAxisPointer';
import Model from 'echarts/lib/model/Model';
import type { CommonAxisPointerOption } from 'echarts/lib/util/types';
import { zrUtil } from 'echarts/core';
import { parsePercent } from 'echarts/lib/util/number';
import { clamp } from '../../../util/math';
import { Option } from '../../../core/option';

type AxisPointerModel = Model<CommonAxisPointerOption>;
type AxisValue = CommonAxisPointerOption['value'];
type DvShadowStyle = Option['axisPointer']['shadowStyle'];

// eslint-disable-next-line @typescript-eslint/unbound-method
const originMakeElOption = CartesianAxisPointer.prototype
  .makeElOption as BaseAxisPointer['makeElOption'];

CartesianAxisPointer.prototype.makeElOption = function makeElOption(
  elOption: AxisPointerElementOptions,
  value: AxisValue,
  axisModel,
  axisPointerModel: AxisPointerModel,
  api
) {
  // echarts内部对axisPointer图形属性的解析函数
  originMakeElOption(elOption, value, axisModel, axisPointerModel, api);

  if (elOption.graphicKey !== 'Rect') {
    return;
  }
  const half = 0.5;
  const { axis } = axisModel;
  const axisDimIndex = axis.dim === 'x' ? 0 : 1;
  const pixelValue = axis.toGlobalCoord(axis.dataToCoord(value, true));
  const shadowStyle = axisPointerModel.get('shadowStyle') as DvShadowStyle;
  const bandWidth = axis.getBandWidth();
  const maxWidth = shadowStyle && shadowStyle.dvMaxWidth;
  if (!zrUtil.isNumber(maxWidth) && !zrUtil.isString(maxWidth)) {
    return;
  }

  const shadowWidth = clamp(
    elOption.pointer.shape[['width', 'height'][axisDimIndex]] as number,
    1,
    parsePercent(maxWidth, bandWidth)
  );

  elOption.pointer.shape[['width', 'height'][axisDimIndex]] = shadowWidth;
  elOption.pointer.shape[['x', 'y'][axisDimIndex]] = pixelValue - shadowWidth * half;
};

export function install(registers: EChartsExtensionInstallRegisters) {
  registers.registerUpdateLifecycle('afterinit', () => {});
}
